import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { TopicPage } from './pages/TopicPage';
import { ContentPage } from './pages/ContentPage';
import { Dashboard } from './pages/Dashboard';
// import { AuthPage } from './pages/AuthPage';
import { PaymentPage } from './pages/PaymentPage';
import { HomePage } from './pages/HomePage';
import { FlashcardsPage } from './pages/FlashcardsPage';
import { SpeedrunPage } from './pages/SpeedrunPage';
import { BlogImportPage } from './pages/BlogImportPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
import { CodeSpacePage } from './pages/CodeSpacePage.tsx';
import {Sidebar} from './components/Sidebar.tsx'
import { useAuth } from './hooks/useAuth';
import { Toaster } from './components/ui/toaster';
import { Navigation } from './components/Navigation';
import {CodeSpace} from "@/components/CodeSpace.tsx";
// import BfsContentPage from "@/pages/BfsContentPage.tsx";
import DailyMoodLifterPage from "@/pages/DailyMoodLifterPage.tsx";
import {MspaintPage} from "@/pages/MspaintPage.tsx";

function PrivateRoute({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { isAuthenticated, isAdmin } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/auth');
    } else if (adminOnly && !isAdmin) {
      navigate('/content');
    }
  }, [isAuthenticated, isAdmin, adminOnly, navigate]);
  
  if (!isAuthenticated || (adminOnly && !isAdmin)) {
    return null;
  }
  
  return <>{children}</>;
}

export function App() {
  return (
    <>
      <Router>
        <Navigation />
        <Routes>
          {/*<Route path="/auth" element={<AuthPage />} />*/}
          <Route path="/home" element={<HomePage />} />
            <Route path="/happy" element={<DailyMoodLifterPage />} />
          <Route path="/coming-soon" element={<ComingSoonPage />} />
          <Route 
            path="/topic/:slug" 
            element={
              <PrivateRoute>
                <TopicPage />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/content" 
            element={
             <PrivateRoute>
                <ContentPage />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/dashboard" 
            element={
             <PrivateRoute adminOnly>
                <Dashboard />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/payment" 
            element={
             <PrivateRoute>
                <PaymentPage />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/flashcards" 
            element={
             <PrivateRoute>
                <FlashcardsPage />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/speedrun" 
            element={
             <PrivateRoute>
                <SpeedrunPage />
             </PrivateRoute>
            } 
          />
          <Route 
            path="/blog-import" 
            element={
             <PrivateRoute adminOnly>
                <BlogImportPage />
             </PrivateRoute>
            } 
          />
            <Route
                path="/codespace"
                element={
                   <PrivateRoute adminOnly>
                        <CodeSpacePage />
                   </PrivateRoute>
                }
            />
            <Route path="/codespace/:slug/:id" element={
               <PrivateRoute>
                <div className="flex min-h-screen">
                    <Sidebar />
                    <CodeSpace />
                </div>
               </PrivateRoute>
            } />
            <Route
                path="/mspaint/"
                element={
                   <MspaintPage/>
                }
            />
          <Route path="/" element={<Navigate to="/coming-soon" replace />} />
        </Routes>
      </Router>
      <Toaster />
    </>
  );
}